<script setup>
import ProductImageAttachmentForm from '@frontJs/components/forms/projectManagement/ai/ProductImageAttachmentForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, aiProductImageAttachment } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    aiProductImageAttachment: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Pièce jointe - Images produits - IA - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - IA - Images produits - Pièce jointe
    </PageTitle>

    <ProductImageAttachmentForm
        :tenant="tenant"
        :ai-product-image-attachment="aiProductImageAttachment"
    />
</template>
